import { render, staticRenderFns } from "./CuentasPorCobrar.vue?vue&type=template&id=3a569560&"
import script from "./CuentasPorCobrar.vue?vue&type=script&lang=js&"
export * from "./CuentasPorCobrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports